import React from 'react';
import Button from '../../common/Button';
import { openNotificationWithIcon } from '@mss/mss-component-library';
import { notification, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import Api from '../services/Api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

export default function RevokeAllSessionsButton({
  fetchSessions,
}: {
  fetchSessions: () => void;
}) {
  const [t] = useTranslation(['remoteAccess', 'common']);

  const revokeSession = async () =>
    Modal.confirm({
      title: t('Are you sure?'),
      icon: (
        <span className="anticon">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color="#fd9644"
            size="sm"
          />
        </span>
      ),
      content: t(
        'Are you sure you want to revoke all sessions? This is a disruptive action and will potentially impact multiple users.'
      ),
      onOk: async () => {
        let result = await Api.session.revokeall('Revoked');
        if (result.status === 200) {
          let data = await result.json();

          if (data.revoke_count > 0) {
            openNotificationWithIcon(
              notification.success,
              t('All active sessions successfully revoked.'),
              ''
            );
            fetchSessions();
          } else {
            openNotificationWithIcon(
              notification.warning,
              t('There where no active sessions to revoke.'),
              ''
            );
          }
        } else {
          openNotificationWithIcon(
            notification.error,
            t('Sessions could not be stopped'),
            t(
              'Due to technical issues the remote sessions could not be stopped. Please try again later.'
            )
          );
        }
      },
      okButtonProps: { danger: true },
    });

  return (
    <Button onClick={() => revokeSession()} data-ta="StopAllSessionsButton">
      <FontAwesomeIcon icon={faBan} className="mr-1" />
      {t('REVOKE ALL SESSIONS')}
    </Button>
  );
}
